import React, { useState, useEffect } from 'react';
import { Outlet, useLocation, Link } from 'react-router-dom';
import { FaBars, FaArrowLeft } from 'react-icons/fa';
import Sidebar from './Sidebar';
import { UserPreferencesProvider, useUserPreferences } from '../context/UserPreferencesContext';
import { useAppConfig } from '../context/AppConfigContext';

const LayoutChrome = () => {
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem('adminSidebarCollapsed') === 'true');
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const { config } = useAppConfig();
  const { dashboardVersion } = useUserPreferences();

  // The sidebar belongs to the new dashboard (ticket 45). With the old tile grid the tiles ARE the
  // navigation, so the sidebar is hidden and a slim header carries the way back instead — the
  // per-page "Back to Dashboard" links were removed when the sidebar arrived.
  // The admin's own choice wins; only when they have not made one does the org default decide.
  const newDashboard = dashboardVersion
    ? dashboardVersion === 'new'
    : config?.newDashboardEnabled !== false;

  useEffect(() => { setMobileOpen(false); }, [location.pathname]); // close drawer on navigation

  const toggleCollapse = () => setCollapsed((c) => { localStorage.setItem('adminSidebarCollapsed', String(!c)); return !c; });

  // The provider wraps both halves of the feature: the sidebar offers pages to pin, the dashboard
  // below the Outlet renders them.
  return (
    <div className="flex min-h-screen bg-gray-100">
        {newDashboard && mobileOpen && <div className="fixed inset-0 z-30 bg-black/40 md:hidden" onClick={() => setMobileOpen(false)} />}
        {newDashboard && (
          <Sidebar collapsed={collapsed} onToggleCollapse={toggleCollapse}
                   mobileOpen={mobileOpen} onCloseMobile={() => setMobileOpen(false)} />
        )}
        <div className="flex-1 min-w-0 flex flex-col">
          {newDashboard ? (
            <header className="md:hidden flex items-center gap-3 bg-jims-cyan-dark text-white px-4 py-3 shadow">
              <button onClick={() => setMobileOpen(true)} aria-label="Open navigation"><FaBars className="text-xl" /></button>
              <span className="font-semibold">Loope Admin</span>
            </header>
          ) : (
            location.pathname !== '/' && (
              <header className="flex items-center gap-3 bg-jims-cyan-dark text-white px-4 py-3 shadow">
                <Link to="/" className="flex items-center gap-2 font-semibold hover:text-cyan-100">
                  <FaArrowLeft /> Back to Dashboard
                </Link>
              </header>
            )
          )}
          <main className="flex-1 min-w-0 overflow-x-hidden"><Outlet /></main>
        </div>
    </div>
  );
};

// The provider has to sit above the chrome, because the chrome reads the preferences it loads.
const Layout = () => (
  <UserPreferencesProvider>
    <LayoutChrome />
  </UserPreferencesProvider>
);

export default Layout;
